import { calcSalary } from './calcSalary';

export const calcSalaryForOne = (data, element) => {
	return (
		calcSalary(data, element.big_items_count, element.small_items_count) /
		element.delivered_count
	);
};
